<template>
  <nav class="navbar navbar-expand-lg bg-blue border m-lg-4 lg-nav" style="background:#1096fc">
    <div class="container-fluid">
      <!-- <a class="navbar-brand" href="#"></a> -->
      
      <button type="button"
              class="navbar-toggler navbar-toggler-right"
              :class="{toggled: $sidebar.showSidebar}"
              aria-controls="navigation-index"
              aria-expanded="false"
              aria-label="Toggle navigation"
              @click="toggleSidebar">
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
      </button>
      <span class="" style="font-size:18px;color:#FFFFFF"></span>
      <!-- <span class="">{{ user_update }}</span> -->
      <div class="collapse navbar-collapse justify-content-end">
        <ul class="nav navbar-nav mr-left">
          <!-- <li class="nav-item"> 
            <a class="nav-link" href="#" data-toggle="dropdown">
              <i class="nc-icon nc-palette"></i>
            </a>
          </li>
          <base-dropdown tag="li">
            <template slot="title">
              <i class="nc-icon nc-planet"></i>
              <b class="caret"></b>
              <span class="notification">5</span>
            </template>
            <a class="dropdown-item" href="#">Notification 1</a>
            <a class="dropdown-item" href="#">Notification 2</a>
            <a class="dropdown-item" href="#">Notification 3</a>
            <a class="dropdown-item" href="#">Notification 4</a>
            <a class="dropdown-item" href="#">Another notification</a>
          </base-dropdown>
          <li class="nav-item">
            <a href="#" class="nav-link">
              <i class="nc-icon nc-zoom-split"></i>
              <span class="d-lg-block">&nbsp;Search</span>
            </a>
          </li>
        </ul>
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <a class="nav-link" href="#">
              Account
            </a>
          </li>
          <base-dropdown title="Dropdown">
            <a class="dropdown-item" href="#">Action</a>
            <a class="dropdown-item" href="#">Another action</a>
            <a class="dropdown-item" href="#">Something</a>
            <a class="dropdown-item" href="#">Another action</a>
            <a class="dropdown-item" href="#">Something</a>
            <div class="divider"></div>
            <a class="dropdown-item" href="#">Separated link</a>
          </base-dropdown>
       -->
          <li class="nav-item" style="display:flex">
            <!-- <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
              99+
            </span> -->
            <div class="dropdown-notif">
              <span class="totalNotif">{{totalNotif}}</span>
              <img src="/img/icon-notification.svg"/>
              <div class="notif-content">
                <p v-for="(data,key) in listNotif" :key="key" v-bind:class="{'can-click':data.read == 0}" v-on:click="readNotif(data.id)">
                  <span v-if="data.read == 0"></span>
                  {{data.airtime.invoice_no}}
                  <br>
                  {{data.airtime.created_at | timeformatTime}}
                </p>
              </div>
            </div>
            <b-dropdown right style="background-image:url(/img/icon-user.svg);background-repeat: no-repeat;list-style-type:none;margin-left:22px;margin-right:10px">
              <b-dropdown-item href="#">Profile</b-dropdown-item>
              <b-dropdown-item href="#">
                  {{dicts.label_language[dicts.lang]}}
                <a href="#" class="ml-4 py-0 px-1 border-none" style="color:red;font-weight:bold;" @click="changeLang('id')">
                  ID
                </a>
                <a href="#" class=" ml-1 py-0 px-1 border-none" style="font-weight:bold;" @click="changeLang('en')">
                  EN
                </a>
              </b-dropdown-item>
              <b-dropdown-item href="#" v-on:click="logout">{{dicts.label_log_out[dicts.lang]}}</b-dropdown-item>
            </b-dropdown>
            
            
            <!-- <button type="button" class=" ml-1 btn btn-sm btn-danger btn-outline-danger py-0 px-1 border-none" @click="changeLang('id')">
              ID
            </button>
            <button type="button" class=" ml-1 btn btn-sm btn-info btn-outline-primary py-0 px-1 border-none" @click="changeLang('en')">
              EN
            </button> -->
          </li>
          <!-- <li class="nav-item">
            <a href="#" class="nav-link" v-on:click="logout">
              {{dicts.label_log_out[dicts.lang]}}
            </a>
          </li> -->
          <li>
            <span class="" style="color:#FFFFFF;font-weight:bold;">{{ user_update }}</span>
          </li>
        </ul>
          <!-- <datatable :datas="invoiceitems" :structure="invoiceitemTableStructure" :init="loadData">
            <template #customcell={obj}>
                <td>{{ obj.name }}</td>
              
            </template>
          </datatable> -->
      </div>
    </div>
  </nav>
</template>
<script>
import {EventBus} from '../eventbus'
import * as axios from 'axios';
  export default {
    computed: {
      routeName () {
        const {name} = this.$route
        return this.capitalizeFirstLetter(name)
      }
    },
    data () {
      return {
        activeNotifications: false,
        loadData:true,
        invoiceitems:[],
        listNotif:[],
        totalNotif:0,
        invoiceitemTableStructure:[
          //label: nama heading, key: nama object property
          {label:'Name',key:null}
        ],
        dicts:{
              lang:'id',
              label_log_out:{
                  id:'Keluar',
                  en:'Log out'
              },
              label_language:{
                  id:'Bahasa',
                  en:'Language'
              },
          },
        }
    },
    created(){
      this.user_update = localStorage.getItem("currentUser");
      this.dicts.lang = localStorage.getItem('lang');
      EventBus.$on('lang',()=>{
            console.log('changing PO lang')
            this.dicts.lang = localStorage.getItem('lang');
      })

      EventBus.$on('notifHeader',()=>{
          this.getNotifNew();
      })
      this.getNotifNew();
    },
    methods: {
      changeLang(lang){
        localStorage.setItem('lang',lang);
        EventBus.$emit('lang',lang)
      },
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleNotificationDropDown () {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown () {
        this.activeNotifications = false
      },
      toggleSidebar () {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar () {
        this.$sidebar.displaySidebar(false)
      },
      logout(){
        localStorage.removeItem('accessToken')
        this.$router.push('/login')
      },
      getInvoiceItems(url=(this.$baseUrl+'/api/master/pengguna')){
        this.loadData=true
        axios.get(url,{'headers':{
                'Authorization':'Bearer '+localStorage.getItem('accessToken')
            }
        }).then((result)=>{
            console.log(result)
            this.invoiceitems = result.data.data;
            this.loadData=false
        }).catch((err)=>{
          //check if token fail
          if(err.response && err.response.status==401){
            localStorage.removeItem('accessToken')
          this.$router.push('/login')
          }
            console.log(err)
            this.loadData=false
        })
      },
      getNotifNew(url=(this.$baseUrl+'/api/notification/admin')){
        console.log('show log notif');
        axios.get(url,{'headers':{
                'Authorization':'Bearer '+localStorage.getItem('accessToken')
        }
        }).then((result)=>{
            console.log(result);
            this.listNotif = result.data;
            this.totalNotif = 0;
            var thos = this;
            this.listNotif.forEach((data)=>{
              console.log(data,data.read == 0);
              if(data.read == 0){
                thos.totalNotif+=1;
              }
            })
        }).catch((err)=>{
        })
      },
      readNotif($id = ''){
        var url = this.$baseUrl+'/api/notification/admin_read'+'?id='+$id;
        axios.get(url,{'headers':{
                'Authorization':'Bearer '+localStorage.getItem('accessToken')
        }
        }).then((result)=>{
            console.log(result);
        }).catch((err)=>{
        })
      }
    }
  }

</script>
<style scoped>
.m-lg-4 {
    margin: 0 !important;
    /* margin: 0 1.5rem 1rem 1.5rem!important; */
}
.bg-blue {
  background: #003b85;
}
::v-deep.navbar .btn {
    margin:0;
    border:0;
    padding: 5px 10px;
}
::v-deep ul .dropdown-menu {
  top:53px !important;
  left:-142px !important;
}
::v-deep .show > .btn-secondary.dropdown-toggle {
    color: rgb ( 255,  255,  255 ) ;  opacity: 0;
    background-color: rgb ( 255,  255,  255 ) ;  opacity: 0;
    border-color: rgb ( 255,  255,  255 ) ;  opacity: 0;
}
.btn:hover, .btn:focus, .btn:active, .btn.active, .open > .btn.dropdown-toggle {
    color: rgb ( 255,  255,  255 ) ;  opacity: 0 !important;
    background-color: rgb ( 255,  255,  255 ) ;  opacity: 0 !important;
}
.dropdown-notif {
  position: relative;
  display: inline-block;
}

.notif-content {
  display: none;
  position: absolute;
  left: -80px;
  background-color: #f9f9f9;
  min-width: 260px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  padding: 12px 16px;
  z-index: 1;
}

.dropdown-notif:hover .notif-content {
  display: block;
}
.dropdown-notif .notif-content p{
  font-size: 12px;
  border-bottom: 1px solid #dbdbdb;
  padding-bottom: 5px;
}
.dropdown-notif .notif-content p:last-child{
  border-bottom: unset;
}
.dropdown-notif .can-click{
  cursor:pointer;
  position:relative;
}
.dropdown-notif .can-click > span{
  width: 6px;
  height: 6px;
  background: red;
  border-radius: 50px;
  position: absolute;
  left: -10px;
  top: 5px;
}
.dropdown-notif span.totalNotif{
  position: absolute;
  right: 0;
  color: white;
  font-weight: bold;
  min-width: 16px;
  padding:0px 2px;
  height: 15px;
  background: red;
  border-radius: 50px;
  display: flex;
  padding-top: 2px;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  align-content: center;
}
  
</style>